import { Parse } from 'src/boot/parse'
import { Notify, Platform, LocalStorage } from 'quasar'
import { App } from '@capacitor/app'
import { i18n } from 'src/boot/i18n'

export function prepareOrderItems ({ commit, dispatch }, { order, items }) {
  console.log('prepareOrderItems', items)
  const prevItems = order.get('item_orders')
  const ids = prevItems.map(item => item.get('internal_id'))
  const maxId = Math.max(...ids)

  let extras = []
  for (const i in items) {
    if (items[i].get('extras') && items[i].get('extras').length) {
      const newExtras = []
      extras = items[i].get('extras')
      // console.log('prepareOrderItems', extras)
      for (const j in extras) {
        const id = (extras[j].id) ? extras[j].id : extras[j].objectId

        if(id) {
          newExtras.push({
            __type: 'Pointer',
            className: 'RestaurantItemExtra',
            objectId: id
          })
        }
      }
      items[i].set('extras', newExtras)
    }

    if (!items[i].attributes) {
      items[i] = new Parse.Object('RestaurantOrder', items[i])
    }

    items[i].set('restaurant_order_summary', order)
    items[i].set('refund_notified', false)
    items[i].set('internal_id', parseInt(i) + 1 + maxId)

    if(items[i].attributes.restaurant_item) {
      const riId = items[i].attributes.restaurant_item.objectId || items[i].attributes.restaurant_item.id
      if(riId) {
        items[i].set('restaurant_item', {
          __type: 'Pointer',
          className: 'RestaurantItem',
          objectId: riId
        })
      }
    }

    if(items[i].attributes.business) {
      const bId = items[i].attributes.business.objectId || items[i].attributes.business.id
      if (bId) {
        items[i].set('business', {
          __type: 'Pointer',
          className: 'Business',
          objectId: bId
        })
      }
    }

    if(items[i].attributes.meal_item) {
      const mealId = items[i].attributes.meal.objectId || items[i].attributes.meal.id
      if (mealId) {
        items[i].set('meal_item', {
          __type: 'Pointer',
          className: 'RestaurantItem',
          objectId: mealId
        })
      }
    }

    if (order.attributes) {
      if (!items[i].get('order_waiter') && order.get('waiter')) {
        items[i].set('order_waiter', order.get('waiter'))
      }
      if (order.get('table')) {
        items[i].set('table', order.get('table'))
      }

      for (const j in order.get('item_orders')) {
        if (items[i].id === order.get('item_orders')[j].id) {
          items.splice(i, 1)
          break
        }
      }
    }
  }

  return items
}

export async function callWaiter ({ commit, dispatch, state }, { pay = false, childOrders = [], call = false }) {
  await dispatch('update', {
    data: {
      call_waiter: call
    },
    save: true
  })
}

export async function doneRating ({ commit, state }, order = false) {
  if(order) {
    order.set('rated', true)
    await order.save()
  } else {
    state.current.set('rated', true)
    await state.current.save()
  }
}

export function checkOrderFinished ({ commit, dispatch, state }, order = false) {
  if (order === false) {
    order = state.current
  }
  if (
    state.orderId === order.id &&
    (
      order.get('closed_by_admin') ||
      (
        order.get('paid') &&
        order.get('item_orders').length === order.get('item_orders_delivered').length
        && order.get('rated')
      )
    )
  ) {
    commit('ORDERS_MODE_SET', false)
    dispatch('destroy', false)
    return true
  }
  return false
}

export function trackAppState ({ dispatch }) {
  // For tests only!
  // Notify.create({
  //   type: 'positive',
  //   message: 'Start App Tracking!'
  // })
  if (Platform.is.capacitor) {
    App.addListener('appStateChange', async ({ isActive }) => {
      if (isActive) {
        Notify.create({
          type: 'warning',
          message: i18n.global.t('tracker.tracker_refreshing')
        })
        dispatch('startSubscription')
      }
    });
  }
}

export async function startSubscription ({ commit, state, dispatch }) {
  if(state.subscription) {
    state.subscription.unsubscribe()
  }
  let subscription = {}
  subscription = await new Parse.Query('RestaurantOrderSummary')
    .equalTo('objectId', state.current.id)
    .subscribe()

  subscription.on('error', e => {
    console.log('#### Socket Error', e)
  })
  subscription.on('update', async (order) => {
    commit('ORDERS_LOADING', true)

    if (!order.isDataAvailable()) {
      await order.fetch();
    }
    // refresh order items for current data
    for (const i in order.get('item_orders')) {
      await order.get('item_orders')[i].fetch()
    }
    commit('ORDERS_UPDATED', order)
    Promise.all([
      dispatch('getTableOrders', order.get('table')),
      dispatch('payments/getOrderPayments', order, { root: true }),
      dispatch('payments/getRefunds', order, { root: true })
    ]).then(() => {
      dispatch('checkOrderFinished', order)
      commit('ORDERS_LOADING', false)
    }).finally(() => {
      commit('ORDERS_LOADING', false)
    })
  })
  subscription.on('delete', (order) => {
    commit('ORDERS_MODE_SET', false)
    dispatch('destroy')
    commit('ORDERS_LOADING', false)
  })

  commit('ORDERS_SUBSCRIPTION_ADD', subscription)
}

export async function setMode ({ commit }, mode) {
  commit('ORDERS_MODE_SET', mode)
}

export async function refreshCurrent({ commit, state }) {
  if (!state.current) {
    return;
  }

  try {
    commit('ORDERS_LOADING', true);

    // Fetch the latest data for the current order
    const updatedOrder = await state.current.fetch();
    // Save the updated order
    commit('ORDERS_OBJECT_SET', updatedOrder);
  } catch (error) {
    console.error('Error refreshing current order:', error);
  } finally {
    commit('ORDERS_LOADING', false);
  }
}

// deprecated
export async function refresh ({ commit, dispatch, state }, loggedUser) {
  commit('ORDERS_LOADING', true)
  commit('ORDERS_SET_CLIENT_NAME', false)
  const id = LocalStorage.getItem('order.staffOrder')

  let query

  if (id) {
    query = new Parse.Query('RestaurantOrderSummary')
      .include(['item_orders', 'client', 'business', 'general_items'])
      .equalTo('objectId', id)

    query.include('client')
  } else {
    query = new Parse.Query('RestaurantOrderSummary')
      .include(['item_orders', 'client', 'business', 'general_items'])
      .equalTo('client', Parse.User.current())
      .notEqualTo('closed_by_admin', true)
  }

  if (process.env.BUSINESS_ID && process.env.BUSINESS_ID.length) {
    query.equalTo('business', ({
      __type: 'Pointer',
      className: 'Business',
      objectId: process.env.BUSINESS_ID
    }))
  }

  if (id) {
    return query.find()
      .then(async orders => {
        const order = orders[0]

        if (order && order.get('general_items') && order.get('general_items').length) {
          await Parse.Object.fetchAll(order.get('general_items'))
        }

        commit('ORDERS_OBJECT_SET', order)

        // save client name
        const clientName = order.get('extra_client_name')
        const client = order.get('client')
        if (clientName) {
          commit('ORDERS_SET_CLIENT_NAME', clientName)
        } else if (client) {
          commit('ORDERS_SET_CLIENT_NAME', client.get('name'))
        } else {
          commit('ORDERS_SET_CLIENT_NAME', false)
        }

        if (order.get('take_away')) {
          commit('ORDERS_MODE_SET', (order.get('delivery_address') && order.get('delivery_address').length) ? 'delivery' : 'take_away')
        } else {
          commit('ORDERS_MODE_SET', 'eat_in')
        }

        if (order.get('table') && order.get('table').id) {
          dispatch('tables/getOne', order.get('table').id, { root: true }).then(() => {
            dispatch('tables/set', order.get('table'), { root: true })
          })
        }

        Parse.Object.fetchAll(order.get('item_orders')).then(async () => {
          dispatch('items/getOrderItemDetails', order.get('item_orders'), { root: true }).then(() => {
            dispatch('startSubscription')

            // dispatch('trackAppState')
          })
        })

        // set business from order
        // await dispatch('business/set', order.get('business'), { root: true })
        commit('ORDERS_LOADING', false)
      }, ({ code, message }) => {
        dispatch('destroy')
        commit('ORDERS_LOADING', false)
        console.log('#### Order object restore error (' + code + '):', message)
      })
      .finally(() => {
        commit('ORDERS_LOADING', false)
      })
  } else {
    // filter paid, delivered and rated order
    return query.descending('createdAt')
      .limit(1)
      .find()
      .then(async orders => {
        if (
          orders[0] &&
        !(
          orders[0].get('paid') &&
          orders[0].get('item_orders').length === orders[0].get('item_orders_delivered').length
        )
        ) {
          const order = orders[0]

          if (order.get('general_items') && order.get('general_items').length) {
            await Parse.Object.fetchAll(order.get('general_items'))
          }

          commit('ORDERS_OBJECT_SET', order)

          if (order.get('take_away')) {
            commit('ORDERS_MODE_SET', (order.get('delivery_address') && order.get('delivery_address').length) ? 'delivery' : 'take_away')
          } else {
            commit('ORDERS_MODE_SET', 'eat_in')
          }

          if (order.get('table') && order.get('table').id) {
            dispatch('tables/getOne', order.get('table').id, { root: true }).then(() => {
              dispatch('tables/set', order.get('table'), { root: true })
            })
          }

          Parse.Object.fetchAll(order.get('item_orders')).then(async () => {
            dispatch('items/getOrderItemDetails', order.get('item_orders'), { root: true }).then(() => {
              dispatch('startSubscription')
              // dispatch('trackAppState')
            })
          })
          // set business from order
          // await dispatch('business/set', order.get('business'), { root: true })
        } else {
          dispatch('destroy', false)
        }
        commit('ORDERS_LOADING', false)
      }, ({ code, message }) => {
        dispatch('destroy')
        commit('ORDERS_LOADING', false)
        console.log('#### Order object restore error (' + code + '):', message)
      })
      .finally(() => {
        commit('ORDERS_LOADING', false)
      })
  }
}

export async function create ({ commit, dispatch, rootState, state }, { itemOrders, table = false }) {
  let platform = 'cl_web'
  if (Platform.is.capacitor) {
    if (Platform.is.ios) {
      platform += '_ios'
    } else if (Platform.is.android) {
      platform += '_and'
    }
  }
  const scheduledAt = !!rootState.cart.scheduledAt ? rootState.cart.scheduledAt:  undefined

  const orderData =  Object.assign({
    business: rootState.business.business,
    client: Parse.User.current(),
    created_from: platform,
    longest_goal_time: 10,
    rated: false,
    discount_amount: 0,
    discount_percentage: 0,
    guests: 1,
    item_orders_delivered: [],
    item_orders_in_progress: [],
    item_orders_ready: [],
    paid: false,
    special_note: '',
    special_request: rootState.cart.special_request || '',
    start_time: new Date(),
    table: {
      __type: 'Pointer',
      className: 'Table',
      objectId: (table) ? table.id : process.env.TAKE_AWAY_TABLE_ID
    },
    take_away: (state.mode !== 'eat_in'),
    tip: 0,
    extra_client_name: '',
    scheduledAt,
    // meals
  }, state.data)

  // console.log('order data', orderData)
  // The credits guard lives in the server's beforeSave and the cached business object
  // can be stale, so a rejection here is the first the client hears of a shortfall.
  const order = await new Parse.Object('RestaurantOrderSummary', orderData).save()
    .catch(error => {
      Notify.create({
        type: 'negative',
        position: 'top',
        message: error && error.message === 'Business has no order credits'
          ? i18n.global.t('tracker.pay.no_credits_subtitle')
          : i18n.global.t('failed')
      })
      throw error
    })
  const mealOrders = []
  const item_orders = []
  let specialRequest = ''
  let itemAdditionalPrice = 0;

  for (const i in itemOrders) {
    // if it is a part of meal create orders for kitchen
    if(itemOrders[i].get('meal_items')) {
      mealOrders.push(itemOrders[i])
      const selections= itemOrders[i].get('meal_items')

      for(const sel of selections) {
        const selItem = sel.item || sel.restaurant_item || sel.restaurantItem;
        const extras = sel.extras || [];
        specialRequest += sel.special_request ? " " + sel.special_request : "";

        const itemData = {
          restaurant_item: selItem,
          additional_price: 0,
          extras,
          meal_item: itemOrders[i].get('restaurant_item'),
          meal_group: sel.group,
          meal_order: itemOrders[i]
        };
        await dispatch("cart/newItem", itemData, { root: true })

        // then save order item metadata
        const orderItemData = {
          special_request: specialRequest,
          additional_price: itemAdditionalPrice,
        };
        const savedItems = await dispatch("cart/saveItem", { amount: 1, orderItemData },  { root: true })

        savedItems.forEach(i => {
          item_orders.push(i)
        })
      }
    } else {
      item_orders.push(itemOrders[i])
    }
  }

  if (state.mode === 'eat_in') {
    await new Parse.Query('Waiter')
      .equalTo('business', rootState.business.business)
      .find()
      .then(waiters => {
        if (waiters.length) {
          for (const i in waiters) {
            for (const j in waiters[i].get('tables')) {
              if (waiters[i].get('tables')[j].id === order.get('table').objectId) {
                order.set('waiter', waiters[i])
                order.set('order_waiter', waiters[i])
                break
              }
            }
            if (order.waiter) {
              break
            }
          }
        }
      })
      .catch(error => {
        console.log('#### Waiter from table error:', error)
      })
    for (const i in itemOrders) {
      itemOrders[i].set('restaurant_order_summary', order)

      if (!itemOrders[i].order_waiter && order.get('waiter')) {
        itemOrders[i].set('order_waiter', order.get('waiter'))
      }

      itemOrders[i].set('table', order.get('table'))
      // TODO: fix save extras as pointers. It saves as pure object now
    //   const newExtras = []
    //   extras = itemOrders[i].get('extras')
    //   console.log('prepareOrderItems', extras)
    //   for (const j in extras) {
    //     const id = (extras[j].id) ? extras[j].id : extras[j].objectId

    //     if(id) {
    //       newExtras.push({
    //         __type: 'Pointer',
    //         className: 'RestaurantItemExtra',
    //         objectId: id
    //       })
    //     }
    //   }
    //   console.log('newExtras', newExtras)
    //   itemOrders[i].set('extras', newExtras)

    }
  }

  await Parse.Object.saveAll(itemOrders)
  await order.set('item_orders', item_orders).save()

  // save meals logic !!!
  if(mealOrders && mealOrders.length) {
    // const meals = await dispatch('prepareOrderItems', { order, items: mealOrders })
    // await Parse.Object.saveAll(mealOrders)
    // console.log('meals', mealOrders)
    for(const mo of mealOrders) {
      mo.set('meal_item', )
    }
    await order.set('meals', mealOrders).save()
  }

  commit('ORDERS_SET_DATA')
  commit('ORDERS_OBJECT_SET', order)
  dispatch('startSubscription')
  // dispatch('trackAppState')
  // empty cart on create order
  dispatch('cart/reset', null, { root: true })
  return order
}

export async function update ({ commit, state }, { data, order = false, save = false }) {
  commit('ORDERS_LOADING', true)

  if (!order) {
    order = state.current
  }

  for (const i in data) {
    order.set(i, data[i])
  }

  if (save) {
    await order.save()
  }

  commit('ORDERS_UPDATED', order)
  commit('ORDERS_LOADING', false)
}

export async function deleteCurrent ({ dispatch, state }, refresh = true) {
  if (state.current) {
    await state.current.destroy()
  }

  dispatch('destroy', refresh)
}
export async function destroy ({ commit, state }, refresh = true) {
  commit('ORDERS_DESTROY', refresh)
}

export async function setData ({ commit }, data) {
  commit('ORDERS_SET_DATA', data)
}

export async function getTableOrders ({ commit, dispatch, state }, table) {
  commit('ORDERS_TABLE_ORDERS_LOADING', true)
  const tableId = (table && table.id) ? table.id : (table && table.objectId)

  // skip for no real table orders
  if (tableId === process.env.TAKE_AWAY_TABLE_ID) {
    commit('ORDERS_TABLE_ORDERS_LOADING', false)
    return
  }
  // Orders at a table are no longer directly queryable (per-order ACL lock-down on
  // RestaurantOrderSummary). Fetch them through the gated cloud function, which
  // returns the same open Parse objects to a guest present at the table (or staff).
  Parse.Cloud.run('getOpenOrdersByTable', { tableId })
    .then(async tableOrders => {
        console.log('getOpenOrdersByTable', tableOrders)
      const promises = []
      for (const i in tableOrders) {
        if (tableOrders[i].get('general_items') && tableOrders[i].get('general_items').length) {
          promises.push(Parse.Object.fetchAll(tableOrders[i].get('general_items')))
        }
        commit('ORDERS_REMOVE_ALL')
        Promise.all(promises).then(() => {
          for (const i in tableOrders) {
            commit('ORDERS_SAVE_ONE', tableOrders[i])
          }
        })
      }

      // Notify.create({
      //   type: 'warning',
      //   message: i18n.global.tm('order.tracker.refresh_alert')
      // })
      commit('ORDERS_TABLE_ORDERS_LOADING', false)
    }).catch(e => {
      console.log('#### Orders get table orders error:', e)
    })
}

export function addItems ({ commit, dispatch, state }, items) {
  const newItems = state.current.get('item_orders').concat(items)
  state.current.set('item_orders', newItems)
  return state.current.save()
}

export function browse ({ commit }, user) {
  const currentUser = Parse.User.current()
  if (!currentUser) {
    commit('ORDERS_LOADING', false)
    return Promise.resolve()
  }

  commit('ORDERS_LOADING', true)
  const query = new Parse.Query('RestaurantOrderSummary').equalTo('client', currentUser)

  // if (process.env.BUSINESS_ID && process.env.BUSINESS_ID.length) {
  //   query.equalTo('business', ({
  //     __type: 'Pointer',
  //     className: 'Business',
  //     objectId: process.env.BUSINESS_ID
  //   }))
  // }

  query.include(['general_items', 'client', 'business'])

  return query.descending('createdAt').find()
    .then(orders => {
      // console.log('browse all', orders, user)
      for (const i in orders) {
        commit('ORDERS_SAVE_ONE', orders[i])
      }
    })
    .catch(err => {
      console.warn('orders/browse failed', err)
    })
    .finally(() => {
      commit('ORDERS_LOADING', false)
    })
}

export function read ({ commit }, id) {
  commit('ORDERS_LOADING', true)
  return new Parse.Query('RestaurantOrderSummary')
    .include(['client'])
    .get(id)
    .then(order => {
      const clientName = order.get('extra_client_name')
      if (clientName) {
        commit('ORDERS_SET_CLIENT_NAME', clientName)
      }
      commit('ORDERS_SAVE_ONE', order)
    })
    .catch(err => {console.warn('orders/read failed', err)
    })
    .finally(() => {
      commit('ORDERS_LOADING', false)
    })
}

export async function fetchCurrent ({ commit, state }) {
  commit('ORDERS_UPDATED', await state.current.fetch())
}

export async function createByStaff ({ commit, dispatch, rootState, state }, { itemOrders, table = false }) {
  let platform = 'cl_web'
  if (Platform.is.capacitor) {
    if (Platform.is.ios) {
      platform += '_ios'
    } else if (Platform.is.android) {
      platform += '_and'
    }
  }

  const order = await new Parse.Object('RestaurantOrderSummary', Object.assign({
    business: rootState.business.business,
    created_from: platform,
    longest_goal_time: 10,
    rated: false,
    discount_amount: 0,
    discount_percentage: 0,
    guests: 1,
    item_orders_delivered: [],
    item_orders_in_progress: [],
    item_orders_ready: [],
    paid: false,
    special_note: '',
    special_request: '',
    start_time: new Date(),
    table: {
      __type: 'Pointer',
      className: 'Table',
      objectId: (table) ? table.id : process.env.TAKE_AWAY_TABLE_ID
    },
    take_away: (state.mode !== 'eat_in'),
    tip: 0,
    extra_client_name: LocalStorage.getItem('order.client_name') ?? ''
  }, state.data)).save()

  const orderWaiter = await dispatch('getWaiterForCurrentStaffUser')
  if (orderWaiter) {
    order.set('order_waiter', orderWaiter)
  }
  // console.log('order waiter', orderWaiter)
  // console.log('order', order)

  if (state.mode === 'eat_in') {
    await new Parse.Query('Waiter')
      .equalTo('business', rootState.business.business)
      .find()
      .then(waiters => {
        if (waiters.length) {
          for (const i in waiters) {
            for (const j in waiters[i].get('tables')) {
              if (waiters[i].get('tables')[j].id === order.get('table').objectId) {
                order.set('waiter', waiters[i])
                break
              }
            }
            if (order.waiter) {
              break
            }
          }
        }
      })
      .catch(error => {
        console.log('#### Waiter from table error:', error)
      })

    for (const i in itemOrders) {
      itemOrders[i].set('restaurant_order_summary', order)

      itemOrders[i].set('order_waiter', orderWaiter)

      itemOrders[i].set('table', order.get('table'))
    }
  }

  await Parse.Object.saveAll(itemOrders)
  await order.set('item_orders', itemOrders).save()
  commit('ORDERS_SET_DATA')
  commit('ORDERS_OBJECT_SET', order)
  return order
}

export async function getWaiterForCurrentStaffUser ({ rootState }) {
  let waiter = null
  const staffQuery = new Parse.Query('Waiter')
  staffQuery.equalTo('user', Parse.User.current())
  staffQuery.equalTo('business', rootState.business.business)
  staffQuery.include('business')
  staffQuery.include('user')
  staffQuery.include('tables')
  staffQuery.include('tables' + '.' + 'business')
  await staffQuery.first()
    .then(function (result) {
      // console.log('Found relevant waiter for user', result)
      // var thisWaiter = waiterFromKitchen
      // console.log('continue order')
      waiter = result
    }, error => {
      console.log('Didnt find relevant waiter for user', error)
      const staffQuery = new Parse.Query('Kitchen')
      staffQuery.equalTo('user', Parse.User.current())
      staffQuery.equalTo('business', rootState.business.business)
      staffQuery.include('business')
      staffQuery.first().then(function (kitchen) {
        // console.log('Create relevant waiter for user')
        // console.log('Save a new waiter from relevant kitchen for user')
        const newWaiterFromKitchen = new Parse.Object('Waiter')
        newWaiterFromKitchen.set('name', kitchen.get('name').length() > 0 ? kitchen.get('name') : 'Kitchen User')
        newWaiterFromKitchen.set('user', Parse.User.current())
        newWaiterFromKitchen.set('gender', kitchen.get('gender'))
        newWaiterFromKitchen.set('color', kitchen.get('color'))

        if (kitchen.get('image') != null) { newWaiterFromKitchen.set('image', kitchen.get('image')) }

        newWaiterFromKitchen.set('business',
          kitchen.get('business'))

        newWaiterFromKitchen.save()
          .then(function (result) {
            // console.log('Saved relevant waiter for user')
            // var thisWaiter = newWaiterFromKitchen
            // console.log('continue order')
            waiter = newWaiterFromKitchen
          }, function (error) {
            console.warn('###Save relevant waiter for user error: ' + error)
            return null
          })
      })
    })

  return waiter
}

export async function setRefundedShown ({ state, commit, dispatch }, item) {
  item.set('refund_notified', true)

  await item.save()

  commit('DELETE_REFUNDED', item.id)
}

export async function getOrderById ({ state, commit, dispatch }, orderId) {
  const query = new Parse.Query('RestaurantOrderSummary')

  const order = await query.get(orderId)
  return order
}

export async function setCurrentOrder({ state, commit, dispatch }, order) {
	commit('ORDERS_OBJECT_SET', order)

	if (order.get('take_away')) {
		commit(
			'ORDERS_MODE_SET',
			order.get('delivery_address') && order.get('delivery_address').length
				? 'delivery'
				: 'take_away'
		)
	} else {
		commit('ORDERS_MODE_SET', 'eat_in')
	}

  if (order.get('table') && order.get('table').id) {
    dispatch('tables/getOne', order.get('table').id, { root: true }).then(() => {
      dispatch('tables/set', order.get('table'), { root: true })
    })
  }

  Parse.Object.fetchAll(order.get('item_orders')).then(async () => {
    dispatch('items/getOrderItemDetails', order.get('item_orders'), { root: true }).then(() => {
      dispatch('startSubscription')
      // dispatch('trackAppState')
    })
  })
}

export async function restore({ state, commit, dispatch }, businessId) {
  commit('ORDERS_LOADING', true)
  commit('ORDERS_SET_CLIENT_NAME', false)

  let orderId = LocalStorage.getItem('order.staffOrder')

  if(!orderId) {
    orderId = state.orderId
  }

  try {
    if(!orderId) {
      return
    }

    const query = new Parse.Query('RestaurantOrderSummary')
      .include(['item_orders', 'client', 'business', 'general_items'])
      .equalTo('objectId', orderId)

    query.include('client')

    const orders = await query.find()

    const order = orders[0]

    if(!order) {
      dispatch('destroy', false)
      return
    }

    if(order.get('paid') && (order.get('item_orders').length === order.get('item_orders_delivered').length)) {
      commit('ORDERS_DESTROY', false)
      return
    }

    // console.log('order', order, order.get('business').id === businessId)
    if(order && order.get('business').id === businessId) {
      if (order && order.get('general_items') && order.get('general_items').length) {
        await Parse.Object.fetchAll(order.get('general_items'))
      }
      commit('ORDERS_OBJECT_SET', order)

      // save client name
      const clientName = order.get('extra_client_name')
      const client = order.get('client')
      if (clientName) {
        commit('ORDERS_SET_CLIENT_NAME', clientName)
      } else if (client) {
        commit('ORDERS_SET_CLIENT_NAME', client.get('name'))
      } else {
        commit('ORDERS_SET_CLIENT_NAME', false)
      }

      if (order.get('take_away')) {
        commit('ORDERS_MODE_SET', (order.get('delivery_address') && order.get('delivery_address').length) ? 'delivery' : 'take_away')
      } else {
        commit('ORDERS_MODE_SET', 'eat_in')
      }

      if (order.get('table') && order.get('table').id) {
        dispatch('tables/getOne', order.get('table').id, { root: true }).then(() => {
          dispatch('tables/set', order.get('table'), { root: true })
        })
        .finally(() => {
          commit('ORDERS_LOADING', false)
        })
      }

      Parse.Object.fetchAll(order.get('item_orders')).then(async () => {
        dispatch('items/getOrderItemDetails', order.get('item_orders'), { root: true }).then(() => {
          dispatch('startSubscription')

          // dispatch('trackAppState')
        })
      })
      .finally(() => {
        commit('ORDERS_LOADING', false)
      })
    }
  } catch (err) {
    console.warn('orders/restore failed', err)
    dispatch('destroy', false)
  } finally {
    commit('ORDERS_LOADING', false)
  }
}
